if (document.getElementById("header").classList.contains("homepage")) {
    var navBurger = document.getElementById("nav-burger")
    
    window.onscroll = function() {scrollToggle()};

    navBurger.addEventListener('click', event => {
        if (navBurger.classList.contains("opened")) {
            header.classList.add("open");
        } else {
            header.classList.remove("open");
        }
    });
}


function scrollToggle() {
    var header = document.getElementById("header")
    if (document.body.scrollTop > 1 || document.documentElement.scrollTop > 1) {
        header.classList.add("scrolled");
    } else {
        header.classList.remove("scrolled");
    }
}